// src/Buttons/EmpresaButton.js

import React from 'react';
import { Link } from 'react-router-dom';
// Importe o CSS correspondente
import './HomeButtons.css';

// 1. Certifique-se de que ele recebe as props
export default function HomeButton({ currentPath, buttonPath }) {
  // 2. Certifique-se de que ele tem a lógica para verificar se está ativo
  const isActive = currentPath === buttonPath;

  return (
    <Link
      to={buttonPath}
      // 3. Certifique-se de que a classe .active é adicionada aqui
      className={`HomeButton ${isActive ? 'active' : ''}`}
    >
      EMPRESA
    </Link>
  );
}
